export default {
  table_ordering: 'Bestellen aan tafel',
  table: 'Tafel',
  pickup_or_delivery: 'Afhalen of bezorgen',
  asap: 'Zo snel mogelijk',
  served_in: 'Geserveerd binnen {{time}} min',
  not_taking_orders: 'Neemt geen bestellingen aan',
  not_your_table: 'Niet jouw tafel? Scan de code op jouw tafel.',
  eating_here: {
    title: 'Hier eten?',
    back_to_table: 'Bestel naar {{table}}. Wij brengen het naar je toe.',
    scan_code: 'Scan de QR-code op je tafel om ernaartoe te bestellen.',
  },
  notes: {
    table_unavailable: {
      title: 'De QR-code van deze tafel werkt niet meer.',
      text: 'Vraag het aan het personeel. Je kunt nog steeds bestellen om af te halen.',
      text_no_pickup: 'Vraag het aan het personeel.',
    },
    table_ordering_off: {
      title: 'Bestellen aan tafel is nu niet beschikbaar.',
      text: 'Je kunt in plaats daarvan bestellen om af te halen.',
    },
    load_failed: {
      title: 'Kon je tafel niet laden.',
      text: 'Scan de QR-code opnieuw.',
    },
    closed: {
      title: 'Nu gesloten.',
      text: 'Je kunt vanaf {{time}} aan je tafel bestellen.',
      text_later: 'Je kunt aan je tafel bestellen zodra we weer open zijn.',
    },
    paused: {
      title: 'Neemt nu geen bestellingen aan.',
      text: 'Vraag het aan het personeel of probeer het over een paar minuten opnieuw.',
    },
  },
  cart: {
    closed: 'Nu gesloten. Je kunt vanaf {{time}} aan je tafel bestellen. Je mand blijft tot dan bewaard.',
    closed_later: 'Nu gesloten. Je mand blijft bewaard tot we weer open zijn.',
    paused: 'Neemt nu geen bestellingen aan. Je mandje blijft bewaard. Vraag het aan het personeel.',
  },
  cash_note: 'Betaal contant aan de kassa.',
  confirmation: {
    bring_to_table: 'Wij brengen je bestelling naar je tafel.',
    your_table: 'Jouw tafel',
    moved_table: 'Naar een andere tafel verhuisd? Geef het personeel je bestelnummer <strong>{{number}}</strong> door.',
  },
  served: 'Geserveerd',
};
